module.exports = __webpack_public_path__ + "img/icon-menu-lien.b2e027e3.svg";